/* import __COLOCATED_TEMPLATE__ from './external-billing-banner.hbs'; */
import Component from '@glimmer/component';
import styles from './external-billing-banner.module.scss';

export default class SiteBillingExternalBillingBanner extends Component {
  styles = styles;
}
